import Entity from '../entity'
import Address from './address'

export default class Customer extends Entity<number>{
    code: string;
    document: string;
    document_full: string;
    company: string;
    fullname: string;
    firstname: string;
    lastname: string;
    email: string;
    birthdate: string;
    active: boolean;
    gender_id: number;
    person_type_id: number;
    document_type_id: number;
    group_id: number;
    level_id: number;

    address: any;
    username: string;
    group: any;
    document_type: any;
    address_full: string;
}


